import React, { createContext, ReactNode, useContext } from "react";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";
import { appRoutes } from "../../routes/routes";

type DashboardType = {
  dashboardNavBar: Array<DashboardNavBarType>;
  //handleClickBottomNav: (index: number) => void;
};

type DashboardNavBarType = {
  icon: string;
  name: string;
  routeName: string;
};

const DashboardContext = createContext<DashboardType | undefined>(undefined);

export const DashboardContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const type: number = ResponsiveDeviceType();
  let dashboardNavBar: Array<DashboardNavBarType> = [
    { icon: "home", name: "home", routeName: appRoutes.routeNameHome },
    { icon: "search", name: "search", routeName: appRoutes.routeNameSearch },
    { icon: "chats", name: "chats", routeName: appRoutes.routeNameChats },
    { icon: "notices", name: "notices", routeName: appRoutes.routeNameNotices },
    {
      icon: "settings",
      name: "settings",
      routeName: appRoutes.routeNameSettings,
    },
  ];

  if (type === 3) {
    dashboardNavBar = dashboardNavBar.slice(1);
  }

  //const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
  /* const handleClickBottomNav = (index: number) => {
    console.log(`index: ${index}`);
    setDashboadNavBarActiveIndex(index);
  }; */

  return (
    <DashboardContext.Provider
      value={{
        dashboardNavBar,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

// IMPORT / USE CONTEXT ///////////////////////////////////////////////////////////////////
export const DashboardContextImport = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error(
      "DashboardContextImport must be used within a DashboardContextProvider"
    );
  }
  return context;
};
